// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ErrorText_errorText__AyhjJ"};